<style lang="scss" scoped>
@include component(directory) {
	@include part(select) {
		width: 100%;
	}
}
.custom-width {
	width: 400px;
}
</style>
<style lang="scss">
.el-table__empty-text {
	position: static;
}
i.el-icon-question {
	color: orange;
	margin-left: 5px;
}
</style>

<template>
	<div>
		<app-header>
			<template slot="header">
				<div class="d-flex">
					<h1><i class="fe fe-activity"></i> Activity</h1>
					<div class="ml-auto custom-width">
						<el-input placeholder="Search activity" v-model="search" prefix-icon="el-icon-search"></el-input>
					</div>
				</div>
			</template>
		</app-header>
		<div class="container">
			<div class="main-panel directory">
				<loading v-if="!activities && $apollo.loading"></loading>
				<el-table v-else class="custom-table" :data="paginated" style="width: 100%">
					<template slot="empty">
						<empty message="Nothing to see here yet"></empty>
					</template>
					<el-table-column width="200" label="Action">
						<template slot-scope="scope">
							<el-tag :type="type(scope.row.type)">{{ scope.row.type | unslug | past_tense | capitalize }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="Name">
						<template slot-scope="scope">
							<span v-if="['sync_finish', 'sync_start'].includes(scope.row.type)">Automatic sync</span>
							<span v-else-if="['error'].includes(scope.row.type)">{{ scope.row.name }} [{{ scope.row.id }}]</span>
							<span v-else>{{ scope.row.name }}</span>
							<a
								href="http://help.wonde.com/en/articles/4460263-precondition-check-failed-error-when-provisioning-classroom-memberships"
								target="_blank"
								v-if="scope.row.message && scope.row.message.includes('Precondition check failed')"
							>
								<i class="el-icon-question"></i>
							</a>
						</template>
					</el-table-column>
					<el-table-column prop="created_at" label="Date">
						<template slot-scope="scope">{{ moment(scope.row.created_at).format("LLL") }}</template>
					</el-table-column>
				</el-table>
				<div v-if="!$apollo.loading && activities.length" class="main-panel__footer">
					<el-pagination background layout="prev, pager, next" :current-page.sync="page" :page-size="per_page" :total="activities.length"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import gql from "graphql-tag";
import moment from "moment";

export default {
	data() {
		return {
			moment,
			page: 0,
			search: null,
			per_page: 50,
			loading: false,
			skip: false
		};
	},

	events: {
		"window-inactive"(state) {
			this.$apollo.queries.activities.skip = state;
		}
	},

	methods: {
		type(type) {
			switch (type.toLowerCase()) {
				case "class_archive":
				case "user_unmatch":
					return "warning";
					break;
				case "user_remove":
				case "error":
					return "danger";
					break;
				case "sync_start":
				case "sync_finish":
				case "group_ignore":
				case "group_ignore":
				case "user_skip":
					return "info";
					break;
				default:
					return "success";
					break;
			}
		}
	},

	computed: {
		paginated() {
			return _.slice(this.filtered, (this.page - 1) * this.per_page, (this.page - 1) * this.per_page + this.per_page);
		},
		filtered() {
			let array = this.activities;
			if (this.search) {
				let term = this.search.toLowerCase().replace(/\s/g, "");
				array = _.filter(array, row => {
					return (
						row.name
							.toLowerCase()
							.replace(/\s/g, "")
							.search(term) !== -1
					);
				});
			}
			return array;
		}
	},

	apollo: {
		activities: {
			query: gql`
				{
					Activities(sortOrder: "desc") {
						id
						type
						name
						message
						created_at
					}
				}
			`,
			pollInterval: 5000,
			// fetchPolicy: "cache-and-network",
			update: r => r.Activities
		}
	}
};
</script>
